import { Flex } from "@chakra-ui/layout";
import { Tag } from "@chakra-ui/react";

interface TagStatusProps {
  icon?: React.ReactNode;
  title: string;
  colorScheme: string;
  id?: string;
}

export default function Props({
  icon,
  title,
  colorScheme,
  id,
}: TagStatusProps) {
  return (
    <Flex id={id}>
      <Tag
        rounded={5}
        px={2}
        py={1.5}
        gap={1}
        colorScheme={colorScheme}
        size="sm"
        fontSize={10}
      >
        {icon}
        {title}
      </Tag>
    </Flex>
  );
}
